<template>
    <div v-show="!$store.getters.appLoading">
      <div v-if="noDreams">
        <EmptyState variant="4" title="Become the designer of your life." subtitle="Give yourself a destination, a point in the future to which you focus all your effort. Don't think about the 'how', think about the 'why'." subtitle2="Who do you want to become, what do you deeply want to experience in one year?"/>
      </div>
      <div v-else>

      </div>
      <draggable
          :list="dreams"
          handle=".handle"
          ghost-class="ghost-dream"
      >
          <template v-for="dream in dreams">
            <Dream
              :key="`dream_${dream.id}`"
              v-if="dream"
              :dream="dream"
              :showGoalStats="false"
              :focusMode="false"
              class="dream cursor-pointer mb-4"
              :class="$store.getters.handleClass"
              @editDream="$emit('editDream', dream)"
            />
          </template>
      </draggable>
  </div>
</template>
<script>
import _ from 'lodash'
import draggable from 'vuedraggable'
import AddNew from './AddNew'
import EditForm from './EditForm'
import ImportDreamDialog from './ImportDreamDialog'
import Dream from './Dream'

import DreamsPreview from '../Preview/DreamsPreview'
import trackAnalytics from '@/helpers/trackAnalytics'
import Sidebar from '../Generic/Sidebar'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    draggable,
    AddNew,
    EditForm,
    Dream,
    DreamsPreview,
    ImportDreamDialog,
    Sidebar,
    VuePerfectScrollbar,
  },
  props: {
    focusMode: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    openDialog: {
      type: Boolean,
      required: false,
      default: () => false,
    }
  },
  data () {
    return {
      sidebarActive: false,
      editedEntity: null,
      dreams: [],
      dreamsLoading: false,
      dreamsOrder: {},
      dreamDefaults: {},
      importDreamDialogOpen: false,
      welcomeMessage: false,
    }
  },
  watch: {
    '$store.getters.dreams': {
      immediate: true,
      handler () {
        this.loadDreams()
      }
    },
    '$store.getters.goals': {
      immediate: true,
      handler () {
        this.loadDreams()
      }
    },
    'dreams': {
      immediate: false,
      handler (dreams) {
        if (!this.dreamsLoading) {
          this.updateDreamsOrder(dreams)
        }
      }
    },
  },
  computed: {
    noDreams () {
      return _.size(this.dreams) === 0
    },
  },
  methods: {
    async loadDreams () {
      this.dreamsLoading = true
      this.dreams = this.$store.getters.dreams

      setTimeout(() => { this.dreamsLoading = false }, 500)
    },
    // addDreamDialog () {
    //   this.editedEntity = this.dreamDefaults
    // },
    // editDreamDialog (dream) {
    //   this.editedEntity = dream
    // },
    // closeDreamDialog () {
    //   this.editedEntity = null
    //   this.loadDreams()
    // },
    showDreamDetail (dream) {
      console.log("DREEEAAAAM", dream)
      this.$router.push({name: 'dream-detail', params: { dreamId: dream.id }})
    },
    updateDreamsOrder (dreams) {
      _.each(dreams, async (dream, order) => {
        await this.$store.dispatch('UPDATE_DREAM_ORDER', { dream, order })
      })
      trackAnalytics(this, 'app_action', 'change_dream_order', null, this.$store.getters.daysFromRegistration)
    },
    setImportDreamDialog (isOpen) {
      this.importDreamDialogOpen = isOpen
    }
  }
}
</script>
<style>
  .ghost-dream {
    opacity: 0.2;
  }

  .divider {
    margin-left: 30%;
    margin-right: 30%;
  }

  p.emphasize {
    font-size: 150%;
  }

</style>
